import { Employee } from './Employee';
import { Department } from './Department';

export class Cart {
    public departments: Department[];
    public employees: Employee[];

    constructor() {
        this.employees = new Array<Employee>();
        this.departments = new Array<Department>();
    }
}
